import { inject, observer } from "mobx-react";
import React, { Component } from "react";
import { Redirect, Route, RouteComponentProps, Switch, withRouter } from "react-router";
import { compose } from "recompose";

import AddToHomeScreenPrompt from "nvent-web/components/AddToHomeScreenPrompt";
import { Notifications } from "nvent-web/components/Notifications/Notifications";
import AddRoom from "nvent-web/scenes/AddRoom";
import { certifiedPageFinishedForLocale } from "nvent-web/scenes/CertifiedPro/certifiedPageFinishedForLocale";
import { CertifiedProPage } from "nvent-web/scenes/CertifiedPro/CertifiedProPage";
import { NonCertifiedProPage } from "nvent-web/scenes/CertifiedPro/NonCertifiedProPage";
import CustomerSupportNumbers from "nvent-web/scenes/CustomerSupportNumbers/CustomerSupportNumbers";
import EditProject from "nvent-web/scenes/EditProject";
import EditRoom from "nvent-web/scenes/EditRoom";
import NewProject from "nvent-web/scenes/NewProject";
import ProjectDetails from "nvent-web/scenes/ProjectDetails";
import FinishedProjects from "nvent-web/scenes/Projects/FinishedProjects";
import OpenProjects from "nvent-web/scenes/Projects/OpenProjects";
import RoomDetails from "nvent-web/scenes/RoomDetails";
import SelectionGuide from "nvent-web/scenes/SelectionGuide/SelectionGuide";
import Tests from "nvent-web/scenes/Tests";
import UserSettings from "nvent-web/scenes/UserSettings";
import withTracker from "nvent-web/services/withTracker";
import AppStore from "nvent-web/stores/App";
import { NotificationsStore } from "nvent-web/stores/Notifications";
import { UserStore } from "nvent-web/stores/User";

import { Advertisements } from "./Advertisements";
import Header from "./Header";
import { Sidebar } from "./Sidebar/Sidebar";

export interface AuthenticatedAppInnerProps extends RouteComponentProps {
  app: AppStore;
  notifications: NotificationsStore;
  user: UserStore;
}

export class AuthenticatedAppInner extends Component<AuthenticatedAppInnerProps> {
  render() {
    const {
      notifications,
      user: { certifiedProNumber },
      app,
    } = this.props;

    return (
      <Sidebar>
        <Header />
        <Notifications notifications={notifications} />
        <Switch>
          <Route path="/settings" exact={true} component={UserSettings} />
          <Route path="/projects/open" exact={true} component={OpenProjects} />
          <Route path="/projects/new" exact={true} component={NewProject} />
          <Route path="/projects/finished" exact={true} component={FinishedProjects} />
          <Route path="/projects/:projectId" exact={true} component={ProjectDetails} />
          <Route path="/projects/:projectId/edit" exact={true} component={EditProject} />
          <Route path="/projects/:projectId/rooms/new" exact={true} component={AddRoom} />
          <Route path="/projects/:projectId/rooms/:roomId" exact={true} component={RoomDetails} />
          <Route path="/projects/:projectId/rooms/:roomId/products/:productId/tests" exact={true} component={Tests} />
          <Route path="/projects/:projectId/rooms/:roomId/edit" exact={true} component={EditRoom} />
          {certifiedPageFinishedForLocale(app.locale, Boolean(certifiedProNumber)) && (
            <Route
              path="/certifiedpro"
              exact={true}
              component={certifiedProNumber ? CertifiedProPage : NonCertifiedProPage}
            />
          )}
          <Route path="/customer-support" exact={true} component={CustomerSupportNumbers} />
          <Route path="/projects/:projectId/rooms/:roomId/selection-guide" component={SelectionGuide} />
          <Redirect to="/projects/open" />
        </Switch>
        <AddToHomeScreenPrompt />
        <Advertisements />
      </Sidebar>
    );
  }
}

export const AuthenticatedApp = compose<AuthenticatedAppInnerProps, {}>(
  withRouter,
  withTracker,
  inject("app", "notifications", "user"),
  observer
)(AuthenticatedAppInner);
